<!--
패키지 정보 수정에서 사용되는 textbox
-->
<template>
    <input
        type="text"
        class="uk-input"

        :class="classObject"
        :value="value"
        @input="updateValue"
        @focus="focus"
        @focusout="focusout"

        @keyup.left="$emit('prev')"
        @keyup.enter="$emit('save')"
        @keyup.right="$emit('next')"
    />
</template>

<script>
    export default {
        // v-model 처리
        model: {
            prop: 'value',
            event: 'update:value'
        },
        props: {
            /**
             * input 요소의 값
             */
            value: {
                type: [String, Number],
                default: '',
            },

        },
        data: function () {
            return {
                // 포커싱 여부
                isFocus: false,
            };
        },
        computed: {
            /**
             * 클래스 명
             * */
            classObject: function () {
                return {
                    'focus': this.isFocus,
                }
            },
        },
        watch: {
        },
        mounted: function () {

        },
        methods: {
            focus: function () {
                this.setFocusState(true);
            },
            focusout: function () {
                this.setFocusState(false);
            },
            /**
             * isFocus 의 상태를 설정한다.
             * @param bool 상태
             */
            setFocusState: function (bool) {
                this.isFocus = bool;
                this.$emit('update:is-focus', bool); // 이벤트 발생
            },
            /**
             * 현재 컴포넌트의 input 요소에 포커스를 준다.
             * */
            inputFocus: function () {
                this.$el.focus();
            },


            /**
             * input 의 값이 변경되었음을 알리는 이벤트 발생
             *  - 리스너에 변경된 값을 인자로 전달
             * @param event vue 이벤트 객체
             * */
            updateValue: function (event) {
                this.$emit('update:value', event.target.value);
            },
        }
    }
</script>

<style lang="scss" scoped>

    input {
        color: #1e87f0;
        font-size: 2rem;
        height: 4rem;
        text-align: center;
        border: 1px solid #333;

        &.focus {//포커싱 상태
            border-color: #1e87f0;
            color: #1e87f0;
        }
    }
</style>